import React from 'react'
import { useTranslation } from 'react-i18next'
import { useBlocker } from 'react-router'
import { useBeforeUnload } from 'react-use'

import { Suspense } from '~/components/elements/Suspense'
import { checkCurrentSurvey } from '~/hoc/checkCurrentSurvey'
import { useIsCommentMapDirty } from '~/hooks/jotai'
import { useLogEventOnMount } from '~/hooks/useLogEventOnMount'
import { useSurveyQuery } from '~/hooks/useSurveyQuery'

import {
  commentBySegmentDisplayTypeAtom,
  savedCommentBySegmentDisplayTypeAtom,
} from './atoms'
import { CustomerAttributeAnalysis } from './components/CustomerAttributeAnalysis'
import { useResetOnUnmount } from './hooks/useResetOnUnmount'

export const CustomerAttributeAnalysisPage = checkCurrentSurvey(() => {
  const { t } = useTranslation()
  const { isLoading } = useSurveyQuery()
  const isDirty = useIsCommentMapDirty(
    commentBySegmentDisplayTypeAtom,
    savedCommentBySegmentDisplayTypeAtom,
  )
  const dirtyMessage = t(
    'edited_content_has_not_been_saved_do_you_still_want_to_leave',
  )

  const blocker = useBlocker(
    ({ currentLocation, nextLocation }) =>
      isDirty && currentLocation.pathname !== nextLocation.pathname,
  )

  useBeforeUnload(isDirty, dirtyMessage)
  useLogEventOnMount('Access to customer attribute analysis')
  useResetOnUnmount()

  React.useEffect(() => {
    if (blocker.state === 'blocked') {
      const isConfirmed = window.confirm(dirtyMessage)
      if (isConfirmed) {
        blocker.proceed()
      } else {
        blocker.reset()
      }
    }
  }, [blocker, dirtyMessage])

  return (
    <Suspense loading={isLoading}>
      <CustomerAttributeAnalysis />
    </Suspense>
  )
})
